import api from "src/spintr/SpintrApi";
import { IShareSubmitPayload, IShareTarget } from "../components/ShareModal/ShareModal.types";
import { uberTypeToShareTargetType } from "../components/ShareModal/shareTargetConfig";

function mapTokenizerToShareTarget(item: any): IShareTarget | null {
    const type = uberTypeToShareTargetType(item.type);
    if (!type) {
        return null;
    }

    const disabled = type === "group" && item.chatEnabled === false;

    return {
        type,
        id: item.id,
        name: item.name,
        imageUrl: item.imageUrl,
        info: item.info,
        disabled,
        disabledReasonKey: disabled ? "SHARE_DISABLED_GROUP_NO_CHAT" : undefined,
    };
}

export interface IShareTargetSearchPage {
    items: IShareTarget[];
    hasMore: boolean;
}

export async function searchShareTargetsAsync(
    searchPhrase: string,
    skip: number,
    take: number,
    includeDepartments: boolean = true,
): Promise<IShareTargetSearchPage> {
    const response = await api.get("/api/v1/targets", {
        params: {
            excludeAll: true,
            excludeUsers: false,
            excludeGroups: false,
            excludeDepartments: !includeDepartments,
            excludeOffices: true,
            excludeRoles: true,
            excludeEmptyRoles: true,
            excludeTargetGroups: true,
            excludeCompanies: true,
            excludeSupplierGroups: true,
            shareableGroupsOnly: false,
            includeChatStatus: true,
            searchPhrase,
            skip,
            take,
            includeDeleted: false,
        },
    });

    const data = response.data || [];

    return {
        items: data
            .map(mapTokenizerToShareTarget)
            .filter((target: IShareTarget | null): target is IShareTarget => target !== null),
        hasMore: data.length >= take,
    };
}

// Recently shared-to targets. Shares the tokenizer mapper (same fields, incl. chatEnabled).
export async function getRecentShareTargetsAsync(take: number = 8): Promise<IShareTarget[]> {
    const response = await api.get("/api/v1/share/recent", { params: { take } });

    return (response.data || [])
        .map(mapTokenizerToShareTarget)
        .filter((target: IShareTarget | null): target is IShareTarget => target !== null);
}

export async function submitShareAsync(payload: IShareSubmitPayload): Promise<void> {
    await api.post("/api/v1/share", payload);
}

export async function getSharePreviewAsync(uberId: number): Promise<any | null> {
    try {
        const response = await api.get("/api/v1/share/preview", { params: { uberId } });
        return response.data || null;
    } catch (error: any) {
        const status = error?.response?.status;
        if (status === 403 || status === 404) {
            return null;
        }
        throw error;
    }
}
